import {
  CbesApi,
  ChatApi,
  ChatUatApi,
  DashboardApi,
  DlqApi,
  DlqRedriveApi,
  DownloadS3FileApi,
  OmsReportsApi,
  InvestigationsApi,
  PaymentRedriveApi,
  PermissionsApi,
  UatProjectsApi,
  PsnsRedriveApi,
  RedriveApi,
  ShadowTestApi,
  TransactionsApi,
  PublishMockAcadiaInvoiceApi,
} from "./generated-src";

import { getAppSetting } from "../config/AppSettings";
import { Configuration } from "./generated-src/configuration";

export function DetailsApiFactory() {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new CbesApi(new Configuration({ basePath: apiBasePath }));
}

export function DlqInfoApiFactory(): DlqApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DlqApi(new Configuration({ basePath: apiBasePath }));
}

export function DlqRedriveInfoApiFactory(): DlqRedriveApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DlqRedriveApi(new Configuration({ basePath: apiBasePath }));
}

export function DashboardApiFactory(): DashboardApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DashboardApi(new Configuration({ basePath: apiBasePath }));
}

export function OmsReportsApiFactory(): OmsReportsApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new OmsReportsApi(new Configuration({ basePath: apiBasePath }));
}

export function RecentTransactionsApiFactory(): TransactionsApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new TransactionsApi(new Configuration({ basePath: apiBasePath }));
}

export function ShadowTestApiFactory(): ShadowTestApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new ShadowTestApi(new Configuration({ basePath: apiBasePath }));
}

export function UatProjectsApiFactory(): UatProjectsApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new UatProjectsApi(new Configuration({ basePath: apiBasePath }));
}

export function RedriveApiFactory(): RedriveApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new RedriveApi(new Configuration({ basePath: apiBasePath }));
}

export function PublishMockInvoiceApiFactory(): PublishMockAcadiaInvoiceApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new PublishMockAcadiaInvoiceApi(
    new Configuration({ basePath: apiBasePath })
  );
}

export function DownloadS3FileApiFactory(): DownloadS3FileApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new DownloadS3FileApi(new Configuration({ basePath: apiBasePath }));
}

export function PaymentRedriveApiFactory(): PaymentRedriveApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new PaymentRedriveApi(new Configuration({ basePath: apiBasePath }));
}

export function PsnsRedriveApiFactory(): PsnsRedriveApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new PsnsRedriveApi(new Configuration({ basePath: apiBasePath }));
}

export function ChatApiFactory(): ChatApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new ChatApi(new Configuration({ basePath: apiBasePath }));
}

export function ChatUatApiFactory(): ChatUatApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new ChatUatApi(new Configuration({ basePath: apiBasePath }));
}

export function InvestigationsApiFactory(): InvestigationsApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new InvestigationsApi(new Configuration({ basePath: apiBasePath }));
}

export function PermissionsApiFactory(): PermissionsApi {
  const apiBasePath = `https://${getAppSetting("apiUrl")}/jwt`;
  return new PermissionsApi(new Configuration({ basePath: apiBasePath }));
}
